<template>
  <div class="infoMainBox">
    <div class="title pubTitle">{{dataForm.Title}}</div>
    <div class="time">{{dataForm.PublishTime}}</div>
    <div class="info" v-html="dataForm.Content">
      
    </div>
    <div class="el-loading-mask" style="display: none;">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  export default {
    data(){
      return{
        dataForm:{
          ID:null,
          TypeId: null,
          PublishTime: null,
          Title: null,
          Content: null,
          Sort: null,
        }
      }
    },
    methods:{
      InitNews(id){
        let _this = this
        api.getNewsById({id: id}).then(res => {
          if (res.data.Succeed) {
            _this.dataForm=res.data.Data.Data;
          }
        });
      }
    },
    mounted() {
      if (this.$route.query.id) {
        this.dataForm.ID = this.$route.query.id;
        this.InitNews(this.$route.query.id)
      }
    }
  };
</script>
<style>
  .pubTitle {
    text-align: center;
    margin:0 0 50px;
    padding-top: 50px;
    font-size: 30px;
  }
  .pubHoverImg {
    &:hover{
      transition: 0.5s width ease,0.5s height ease; 
      position: relative;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 105%;
      height: 105%;
      box-shadow: 0 0 10px rgba(0,0,0,0.2);
    }
  }
  .infoMainBox{width:1200px;margin:-40px auto 0}
.infoMainBox .time{text-align:right;font-size:16px;color:#666;margin-bottom:10px}

.infoMainBox img{
	width: 100%;
	height: 100%;
}
</style>









// WEBPACK FOOTER //
// src/pages/MessageCenter/NewsDetail.vue